<template>
  <div>

    <TsHeader/>

    <TsFooter data-fetch-key="performance-all-layout-footer-links"/>

  </div>
</template>

<script setup>

const TsHeader = defineAsyncComponent(
    () => import('~/components/TsHeader.vue')
);


const TsFooter = defineAsyncComponent(
    () => import('~/components/TsFooter.vue')
);



definePageMeta({
  layout: false,
});




onMounted(async () => {
  let layout = useRoute().query.layout;

  if(!layout){
    layout = 'none';
  }

  setPageLayout(layout)

});



</script>